"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isShowProperty = exports.showPropertyDefinition = void 0;
exports.showPropertyDefinition = {
    view: { label: 'Show' },
    constraints: [
        {
            name: 'stencils',
            argument: ['show'],
        },
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'show',
};
const isShowProperty = (prop) => {
    return prop.name === exports.showPropertyDefinition.name;
};
exports.isShowProperty = isShowProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hvdy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Nob3cucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQkFBc0IsR0FBRztJQUNwQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFO0lBQ3ZCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsTUFBTSxDQUFDO1NBQ25CO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLE1BQU07Q0FDbUIsQ0FBQTtBQUkxQixNQUFNLGNBQWMsR0FBRyxDQUFDLElBQWtCLEVBQXdCLEVBQUU7SUFDekUsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDhCQUFzQixDQUFDLElBQUksQ0FBQTtBQUNsRCxDQUFDLENBQUE7QUFGWSxRQUFBLGNBQWMsa0JBRTFCIn0=